import { SESSION_STORAGE_KEYS } from '@/constants/storageKeys'

/**
 * 閲覧済み記事IDの配列を取得
 * @returns 閲覧済み記事IDの配列
 */
export function getViewedArticles(): string[] {
  if (typeof window === 'undefined') return []

  try {
    const storedValue = sessionStorage.getItem(SESSION_STORAGE_KEYS.VIEWED_ARTICLES)
    if (!storedValue) return []

    const parsed = JSON.parse(storedValue)
    if (Array.isArray(parsed) && parsed.every((item) => typeof item === 'string')) {
      return parsed
    }
    return []
  } catch {
    return []
  }
}

/**
 * 記事IDを閲覧済みリストに追加
 * @param articleId 追加する記事ID
 * @returns 追加に成功した場合true
 */
export function addViewedArticle(articleId: string): boolean {
  if (typeof window === 'undefined') return false

  try {
    const viewedArticles = getViewedArticles()

    if (!viewedArticles.includes(articleId)) {
      viewedArticles.push(articleId)
      sessionStorage.setItem(SESSION_STORAGE_KEYS.VIEWED_ARTICLES, JSON.stringify(viewedArticles))
    }
    return true
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Failed to add viewedArticle to sessionStorage:', error)
    }
    // エラー時はリセット
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.VIEWED_ARTICLES, '[]')
    } catch {
      // sessionStorageアクセス失敗は無視
    }
    return false
  }
}
